import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { addIcon, subtractIcon } from 'assets/images';
import useIsMobile from 'utils/useIsMobile';

import './submenu.scss';

const Submenu = ({ item, path }) => {
  const location = useLocation();
  const [subnav, setSubnav] = useState(false);
  const isMobile = useIsMobile();

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <Link
        className="sidebar-link"
        to={item.path}
        onClick={item.methods && showSubnav}>
        <div className="sidebar-menu">
          <span className="sidebar-menu-label">{item.name}</span>
        </div>

        <div className="sidebar-menu-drop-icon">
          {item.methods &&
            ((subnav && (
              <img src={subtractIcon} alt="icon iconOpened" loading="lazy" />
            )) ||
              (!subnav && (
                <img src={addIcon} alt="iconIconclosed" loading="lazy" />
              )))}
        </div>
      </Link>

      {subnav &&
        item.methods
          .sort((a, b) => a.id - b.id)
          .map(subItem => {
            return (
              <Link
                key={`${subItem.id}-${subItem.name}`}
                to={`${path}/${subItem.id}`}
                className={`${
                  isMobile
                    ? 'sidebar-dropdownlink-mobile'
                    : 'sidebar-dropdownlink'
                } ${
                  location.pathname === `${path}/${subItem.id}` && 'active'
                }`}>
                <p
                  className={clsx(
                    'submenuIcon',
                    location.pathname === `${path}/${subItem.id}` &&
                      'activeSubmenuIcon',
                  )}>
                  {(subItem.type === 'GET' && 'GET') ||
                    (subItem.type === 'POST' && 'POST') ||
                    (subItem.type === 'PUT' && 'PUT')}
                </p>
                <span className="sidebar-submenu-label">{subItem.name}</span>
              </Link>
            );
          })}
    </>
  );
};

export default Submenu;
